import {TextField, Typography} from '@mui/material';
import {alpha, styled} from '@mui/material/styles';
import {isNil} from 'lodash';

import {dayjs, formatDateToString, todayString, yearFromNow} from 'utils/dateUtils';

import {DesktopDatePicker} from 'components/DatePicker/DesktopDatePicker';
import {TextFieldProps} from 'components/form-next/TextField';

const SWrapper = styled('div')(({theme}) => ({
  display: 'grid',
  gap: theme.spacing(2),
}));

export const STextField = styled(TextField)(({theme}) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadiusRegular,
    maxWidth: 185,
    ...theme.typography.buttonSmall,

    '& .MuiOutlinedInput-input': {
      height: 44,
      boxSizing: 'border-box',
      padding: theme.spacing(3.5, 4),
      paddingRight: 0,
      textTransform: 'lowercase',
    },

    '& fieldset': {
      borderColor: alpha(theme.palette.primary.main, 0.12),
    },

    '& .MuiButtonBase-root': {
      marginRight: theme.spacing(-1),
    },
  },
}));

export const inforceMinDateValidation = formatDateToString(dayjs('1990-01-01'));
export const inforceMaxDateValidation = todayString;

const TextFieldSlot = (props: TextFieldProps) => {
  return (
    <SWrapper>
      <Typography variant='body3' color='text.secondary'>
        Inforce on
      </Typography>
      <STextField size='small' variant='outlined' {...props} />
    </SWrapper>
  );
};

export const InforceDatePicker = ({
  value,
  onChange,
  disabled,
  onBlur,
  error,
}: {
  value?: number | string | null;
  onChange: (timestamp: string | null) => void;
  onBlur?: () => void;
  disabled?: boolean;
  error?: boolean;
}) => {
  return (
    <DesktopDatePicker
      error={error}
      slots={{
        textField: TextFieldSlot,
      }}
      value={!isNil(value) ? formatDateToString(value) : null}
      onChange={value => onChange(value)}
      onBlur={onBlur}
      minDate={inforceMinDateValidation}
      maxDate={yearFromNow}
      maxValidDate={inforceMaxDateValidation}
      disabled={disabled}
      disableFuture
    />
  );
};
